export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14323.86055dd7.jpg";